module.exports = __webpack_public_path__ + "static/media/CHASIUH_MENU-normal.7fd884e8.png";